var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartEmptyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9872 4.00298C13.214 3.72068 13.4111 3.45358 13.6294 3.20819C14.7147 1.98995 16.0268 1.24294 17.5381 1.05619C19.7405 0.78257 21.6694 1.5361 23.1808 3.38192C24.9507 5.54478 25.4044 8.08116 24.6497 10.889C24.389 11.8575 23.8888 12.6848 23.3631 13.4883C21.9005 15.7228 20.1517 17.6555 18.28 19.4405C16.7433 20.9063 15.1429 22.2896 13.5616 23.6946C13.0953 24.1072 12.9066 24.0963 12.4275 23.6946C9.42181 21.1778 6.51994 18.5263 4.00174 15.3841C3.06695 14.218 2.18727 12.9975 1.58104 11.5622C0.398244 8.75651 1.07443 5.08659 3.1263 3.01058C4.63553 1.48181 6.39912 0.797771 8.40224 1.05184C10.1192 1.269 11.5754 2.13545 12.7095 3.63382C12.7985 3.75325 12.8896 3.87052 12.9893 4.00298H12.9872Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEmptyWhite);
export default __webpack_public_path__ + "static/media/heart_empty_white.c3b0281d90ae69647ae8d89ccd012447.svg";
export { ForwardRef as ReactComponent };